import { useAuth } from '@choco-admin/auth';
import { Card, CardBody, CardHeader } from '@heroui/react';
import React from 'react';

export const DashboardPage: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="p-6 flex items-center justify-center min-h-[60vh]">
      <Card className="max-w-2xl w-full text-center">
        <CardHeader>
          <h1 className="text-4xl font-bold text-foreground mx-auto">
            Welcome to Choco Admin
          </h1>
        </CardHeader>
        <CardBody>
          <p className="text-xl text-foreground-600 mb-6 leading-relaxed">
            Your modern admin dashboard for managing users, buyers, suppliers,
            and orders.
            <br />
            Ready to get started?
          </p>

          {user && (
            <Card className="bg-primary-50 mt-6">
              <CardBody className="p-4">
                <p className="text-sm text-primary-700 font-medium">
                  Logged in as: {user.username}
                </p>
              </CardBody>
            </Card>
          )}
        </CardBody>
      </Card>
    </div>
  );
};
